import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import Text from '@text';
import styleUtils from '../../../../styles/style.utils';
import mediaBreakpoints from '../../../../styles/media-breakpoints';
import themedColor from '../../../../styles/theme/themed-color';
import themedFontSize from '../../../../styles/theme/themed-font-size';

const Inactive = css`
  filter: grayscale(100%) opacity(35%);
`;

const Active = css`
  filter: grayscale(0) opacity(100%);
  p {
    height: 60px;
    transition: all 0.3s;
  }
`;

interface ContainerProps {
  isActive: boolean;
}

const Container = styled.div<ContainerProps>`
  min-width: ${styleUtils.size('MIN_REDIRECT_BUTTON_WIDTH')};
  max-width: ${styleUtils.size('MAX_REDIRECT_BUTTON_WIDTH')};
  width: calc(25% - (2 * ${styleUtils.size('REDIRECT_BUTTON_MARGIN')}));
  margin: ${styleUtils.px(32)} ${styleUtils.size('REDIRECT_BUTTON_MARGIN')} 0;
  padding: ${styleUtils.px(22)};
  background: ${themedColor('GRAY')};
  border-radius: ${styleUtils.px(10)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  /* TODO: change that to different icons */
  ${({ isActive }: ContainerProps): FlattenSimpleInterpolation | undefined =>
    !isActive ? Inactive : undefined}

  &:hover {
    ${Active}
    box-shadow: inset 0px 0px 0px 1px ${themedColor('INPUT_FOCUS_BORDER')};
  }

  ${mediaBreakpoints.greaterThan('M')`
    margin: 0;
  `};
`;

const StyledText = styled(Text)`
  &.ucf-paragraph {
    color: ${themedColor('TEXT_BLUE')};
    text-align: center;
    margin-top: ${styleUtils.px(10)};
    font-weight: 600;
    white-space: pre;
    margin-bottom: 0;
    font-size: ${themedFontSize('BODY')};
  }
`;

const HoveredText = styled(Text)`
  &.ucf-paragraph {
    color: ${themedColor('TEXT_BLUE')};
    text-align: center;
    margin-top: ${styleUtils.px(16)};
    font-weight: 400;
    white-space: pre;
    height: 0;
    overflow: hidden;
    margin-bottom: 0;
    font-size: ${themedFontSize('BODY')};
  }
`;

const ButtonsListItemComponents = { Container, StyledText, HoveredText };

export default ButtonsListItemComponents;
